<template>
  <div class="top-bar">
    <div class="container">
      <div class="left-part">
        <img class="logo" src="@/assets/logo-new.png" alt="">
      </div>
<!--      <div class="centercontent"><a target="_blank" href="https://www.jxvtc.edu.cn/" style="color: white;">学院官网</a></div>-->
      <div class="right-part" v-if="isShowSearch">
        <input class="input" v-model="searchStr" placeholder="咨询搜索" type="text">
        <img class="search" @click="goNewsList" src="@/assets/search-ico.png" alt="">
        <i class="el-icon-search searchIcon" @click="goNewsList"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isMobile () {
      return /Android|Windows Phone|iPhone|iPod/i.test(navigator.userAgent)
    },
    isShowSearch () {
      // 移动端仅首页展示搜索
      if (this.isMobile) {
        return this.$route.name === 'Home'
      }
      return true
    }
  },
  data () {
    return {
      searchStr: ''
    }
  },
  methods: {
    goNewsList () {
      const routerData = this.$router.resolve({ path: 'newsList', query: { searchStr: this.searchStr } })
      window.open(routerData.href, this.isMobile ? '_self' : '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/mixin.scss';
.top-bar {
  height: 87px;
  background-color: #457AE3;
  .container {
    display: flex;
    justify-content: space-between;
    width: $main-width;
    margin: 0 auto;
    .left-part {
      padding-top: 10px;
      .logo {
        width: 362px;
        height: 77px;
      }
    }
    .centercontent{
      padding-top: 37px;
      width: 650px;
      text-align: right;
      color: #fff;
    }
    .right-part {
      display: flex;
      align-items: center;
      width: 180px;
      height: 40px;
      margin-top: 24px;
      padding: 0 10px 0 16px;
      border: 2px solid #fff;
      border-radius: 20px;
      .input {
        padding-right: 10px;
        width: 124px;
        background: transparent;
        border: none;
        outline: none;
        color: #EFEBEA;
        font-size: 14px;
        &::-webkit-input-placeholder {
          color: #EFEBEA;
        }
        &::-moz-input-placeholder {
          color:#EFEBEA
        }
        &::-ms-input-placeholder {
          color:#EFEBEA
        }
      }
      .search {
        display: block;
        margin-top: -4px;
        width: 25px;
        height: 25px;
        cursor: pointer;
      }
      .searchIcon{
        display: none;
        font-size: 1.35rem;
        margin-top: -4px;
        width: 25px;
        height: 25px;
        cursor: pointer;
        line-height: 25px;
        color: #C7C7C7;
      }
    }
  }
}
</style>
